import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';

export interface EntityType {
  value: string;
  label: string;
  searchBy: string;
  path: string;
  tab?: string;
  disabled?: boolean;
  permission?: string;
}

export const entityTypes: EntityType[] = [
  {
    value: 'client',
    label: 'Clients',
    searchBy: 'Name',
    path: ADMIN_ROUTES.client,
    tab: ADMIN_ROUTES.clientGeneral,
    permission: PERMISSIONS.clients.client.read,
  },
  {
    value: 'brand',
    label: 'Brands',
    searchBy: 'Name',
    path: ADMIN_ROUTES.brand.view,
    tab: ADMIN_ROUTES.brand.management,
    permission: PERMISSIONS.brands.brand.read,
  },
  {
    value: 'supplier',
    label: 'Suppliers',
    searchBy: 'Name',
    path: ADMIN_ROUTES.suppliers.view,
    tab: ADMIN_ROUTES.suppliers.general,
    permission: PERMISSIONS.suppliers.supplier.read,
  },
  {
    value: 'item',
    label: 'Items',
    searchBy: 'ID',
    path: ADMIN_ROUTES.items.view,
    tab: ADMIN_ROUTES.items.suppliers,
    permission: PERMISSIONS.items.item.read,
  },
  {
    value: 'lead',
    label: 'Leads',
    searchBy: 'ID',
    path: ADMIN_ROUTES.leads.view,
    tab: ADMIN_ROUTES.leads.general,
    permission: PERMISSIONS.leads.lead.read,
  },
  {
    value: 'deal',
    label: 'Deals',
    searchBy: 'ID',
    path: ADMIN_ROUTES.deals.view,
    tab: ADMIN_ROUTES.deals.purchaseRequest,
    permission: PERMISSIONS.deals.deal.read,
  },
  {
    value: 'task',
    label: 'Tasks',
    searchBy: 'ID',
    path: ADMIN_ROUTES.tasks.view,
    tab: ADMIN_ROUTES.tasks.general,
    permission: PERMISSIONS.tasks.task.read,
  },
  {
    value: 'purchaseRequest',
    label: 'Purchase Requests',
    searchBy: 'ID',
    path: ADMIN_ROUTES.purchaseRequest.view,
    tab: ADMIN_ROUTES.purchaseRequest.general,
    permission: PERMISSIONS.purchaseRequests.purchaseRequest.read,
  },
];
